/**
 * Metric keys whose comparison value is a percentage. TELV1-575.
 *
 * Shared because the statistical table is rendered TWICE — on screen in
 * ComparisonReport and again in the markdown download via
 * formatComparisonExport. Two copies of this list drift the moment a metric
 * is added, and the two surfaces would then disagree. PR review.
 *
 * Counts (completed_interviews, started_interviews) must stay bare, so this
 * is an explicit list rather than a default.
 */
export const PERCENTAGE_METRIC_KEYS = new Set(['completion_rate_pct', 'screening_pass_rate_pct']);

export const isPercentageMetric = (metricKey?: string) =>
  !!metricKey && PERCENTAGE_METRIC_KEYS.has(metricKey);
